// extracted by mini-css-extract-plugin
export default {"main":"S04_main__HZjoa","logoContainer":"S04_logoContainer__qHyqM","content":"S04_content__TAHST","info":"S04_info__rdE9B"};